import { createContext, type AcceptableValue } from "reka-ui";
import type { MaybeRefOrGetter, Ref } from "vue";

export { default as Command } from "./Command.vue";
export { default as CommandShortcut } from "./CommandShortcut.vue";

export type CommandApi = {
	allItems: Ref<Map<string, string>>;
	allValues: Ref<Map<any, string>>;
	allGroups: Ref<Map<string, Set<string>>>;
	filterState: {
		search: string;
		filtered: { count: number; items: Map<string, number>; groups: Set<string> };
	};
	virtual: {
		enabled: Ref<boolean>;
		targets: Ref<Map<string, HTMLDivElement>>;
	};
};

export const [injectCommandContext, provideCommandContext] = createContext<CommandApi>("Command");

export const [injectCommandGroupContext, provideCommandGroupContext] = createContext<{
	id?: string;
}>("CommandGroup");

export const [injectItemContext, provideItemContext] = createContext<{
	id?: string;
	value?: MaybeRefOrGetter<AcceptableValue>;
	select?: () => void;
}>("Item");
